export default __webpack_public_path__ + "static/burning-alf-dc899382654d34993dc1d62ca2f39bc3.png";